import React from 'react';
import PropTypes from 'prop-types';

function TriangleButton({ active, activeColor, color }) {
  return (
    <>
      <path
        d="M624.429 167.404C624.429 178.679 615.29 187.819 604.018 187.819C592.743 187.819 583.603 178.679 583.603 167.404C583.603 156.129 592.743 146.989 604.018 146.989C615.29 146.989 624.429 156.129 624.429 167.404Z"
        fill={active ? activeColor : color}
      />
      <path
        d="M593.218 174.51H614.464L604 155.838L593.218 174.51ZM618.371 176.97H589.25L604.032 151.379L618.371 176.97Z"
        fill="#7DFFBB"
      />
    </>
  );
}

TriangleButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

TriangleButton.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#464A56',
};

export default TriangleButton;
